import React from 'react'
import PropTypes from 'prop-types'
import { IMG_LOGO } from 'constants/imageMapping'
import PaymentDetailsInfo from './payment-details-info'

const PaymentDetailsFields = ({ planDetails: { plan, price, currency, description = [] } }) => {
  return (
    <div className="passport-payment-details">
      <div className="booking-payment-details-header p-5 flex flex-col justify-center items-center bg-secondary-lightgray">
        <div className="banner relative">
          <img
            src={
              'https://media.flyspaces.com/assets/images/main-page-passport-flyspaces.jpg?o=true'
            }
          />
          <div className="passport-pay__plan-details__banner__overlay w-full h-full absolute"></div>
          <div className="passport-pay__plan-details__banner__text absolute text-center w-full p-2 text-white">
            <img alt="passport" src={IMG_LOGO} className="m-0 m-auto w-2/5" width="128" height="23" />
            <h2 className="uppercase font-thin">passport</h2>
            <p>Gain instant access to the best coworking spaces in Southeast Asia!</p>
            <p>Work anywhere, anytime</p>
          </div>
        </div>
        <ul className="booking-payment-details-header-info md:w-2/3 w-full">
          <li className="flex justify-between my-3">
            <p className="text-primary-orange font-bold text-lg">Plan</p>
            <p className="font-normal text-lg w-2/3">{plan}</p>
          </li>
          <li className="flex justify-between my-3">
            <p className="text-primary-orange font-bold text-lg">Price</p>
            <p className="font-normal text-lg w-2/3">{`${currency} ${price}`}</p>
          </li>
          <li className="flex justify-between my-3">
            <p className="text-primary-orange font-bold text-lg">Credits</p>
            <ul className="list-disc w-2/3">
              {description.map((value, key) => (
                <li key={key}>{value}</li>
              ))}
            </ul>
          </li>
        </ul>
      </div>
      <PaymentDetailsInfo amount={`${currency} ${price}`} />
    </div>
  )
}

PaymentDetailsFields.propTypes = {
  planDetails: PropTypes.object,
}

export default PaymentDetailsFields
